
import { Topic } from '@/components/TopicSelector';

export const topics: Topic[] = [
  {
    id: 'parts-of-speech',
    title: 'Parts of Speech',
    arabicTitle: 'أقسام الكلام',
    description: 'Learn about nouns (الأسماء), verbs (الأفعال), and particles (الحروف) in Arabic grammar.',
    questionCount: 48
  },
  {
    id: 'declension',
    title: 'Declension',
    arabicTitle: 'الإعراب',
    description: 'Practice the signs and rules of grammatical case endings in Arabic.',
    questionCount: 30
  },
  {
    id: 'subject-predicate',
    title: 'Subject and Predicate',
    arabicTitle: 'المبتدأ والخبر',
    description: 'Study the nominal sentence structure and its components.',
    questionCount: 30
  },
  {
    id: 'verb-forms',
    title: 'Verb Forms',
    arabicTitle: 'أشكال الفعل',
    description: 'Learn about different verb forms and conjugations in Arabic.',
    questionCount: 30
  },
  {
    id: 'exceptions',
    title: 'Exceptions',
    arabicTitle: 'الاستثناء',
    description: 'Understand how to form and use exceptions in Arabic grammar.',
    questionCount: 30
  },
  {
    id: 'objects',
    title: 'Objects',
    arabicTitle: 'المفاعيل',
    description: 'Study different types of objects in Arabic sentences.',
    questionCount: 30
  }
];
